/* TMF 1.0 — Theme JavaScript */

(function () {
  'use strict';

  // ============================================================
  // Hero carousel
  // ============================================================
  function initHeroCarousel(root) {
    const slides = Array.from(root.querySelectorAll('.tmf-hero__slide'));
    const dots = Array.from(root.querySelectorAll('.tmf-hero__dot'));
    if (slides.length < 2) return;

    let current = 0;
    let timer = null;
    const interval = parseInt(root.dataset.interval, 10) || 6500;

    function show(i) {
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      current = i;
    }

    function next() { show((current + 1) % slides.length); }

    function start() {
      stop();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) return;
      timer = setInterval(next, interval);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach((dot, idx) => {
      dot.addEventListener('click', () => {
        show(idx);
        start();
      });
    });

    // Pause on hover (desktop)
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // Pause when tab not visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop(); else start();
    });

    // Swipe (mobile)
    let touchStartX = null;
    root.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      stop();
    }, { passive: true });
    root.addEventListener('touchend', (e) => {
      if (touchStartX === null) return;
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) {
        if (dx < 0) next();
        else show((current - 1 + slides.length) % slides.length);
      }
      touchStartX = null;
      start();
    });

    show(0);
    start();
  }

  // ============================================================
  // Mobile nav toggle
  // ============================================================
  function initHeaderToggle() {
    const toggle = document.querySelector('.tmf-header__toggle');
    const nav = document.querySelector('.tmf-nav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('tmf-nav--open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    // Close on link click
    nav.addEventListener('click', (e) => {
      if (e.target.tagName === 'A') {
        nav.classList.remove('tmf-nav--open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // ============================================================
  // Init
  // ============================================================
  function init() {
    document.querySelectorAll('.tmf-hero').forEach(initHeroCarousel);
    initHeaderToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
